<template>
  <div>
    <v-tabs
      fixed-tabs
      color="primary"
      slider-color="primary"
    >
      <v-tab
        exact
        :to="{ name: 'invoices' }"
      >
        All invoices
      </v-tab>
      <v-tab
        exact
        :to="{ name: 'invoices', query: { status: 'draft' }}"
      >
        Draft
      </v-tab>
      <v-tab
        exact
        :to="{ name: 'invoices', query: { status: 'open', closed: false}}"
      >
        Outstanding
      </v-tab>
      <v-tab
        exact
        :to="{ name: 'invoices', query: { past_due: true }}"
      >
        Past Due
      </v-tab>
      <v-tab
        exact
        :to="{ name: 'invoices', query: { status: 'paid' }}"
      >
        Paid
      </v-tab>
    </v-tabs>
    <base-stripe-table
      :headers="headers"
      :fetch-action="'listInvoices'"
      :fetch-query="fetchQuery()"
      :items-getter="'getInvoices'"
      :pagination-getter="'getInvoicePagination'"
    >
      <template v-slot:body="{ items }">
        <tbody>
          <tr
            v-for="item in items"
            :key="item.id"
            @click="goto(item)"
            style="cursor: pointer;"
          >
            <td>
                <span
                  :class="{
                    'grey--text': item.status === 'draft'
                  }"
                  v-money="{ amount: item.total, currency: item.currency}"></span>
            </td>
            <td class="text-center">

              <v-tooltip
                bottom
                color="white"
              >
                <template v-slot:activator="{ on }">
                  <v-icon
                    v-if="item.billing_reason === 'subscription_cycle'"
                    small
                    v-on="on"
                    color="grey"
                  >
                    refresh
                  </v-icon>
                </template>

                <span
                  class="black--text">This invoice was created by a recurring subscription</span>
              </v-tooltip>

            </td>
            <td>
              <invoice-status-chip
                :invoice="item"
              />
            </td>
            <td>
              {{ item.customer_name }}<br/>
              <span class="grey--text">{{ item.customer_email }}</span>
            </td>
            <td>{{ item.number }}</td>
            <td v-date="item.due_date"></td>
            <td v-date="item.created"></td>
          </tr>
        </tbody>
      </template>
    </base-stripe-table>
  </div>
</template>
<script>
import BaseStripeTable from '@/components/Common/BaseStripeTable'
import InvoiceStatusChip from "./InvoiceStatusChip"
import { isInvoiceFromSubscription } from "../../services/stripe.service"

export default {
  components: {
    InvoiceStatusChip,
    BaseStripeTable
  },
  methods: {
    fetchQuery() {
      const query = {}

      for (const [ key, value ] of Object.entries(this.$route.query)) {
        query[ key ] = value
      }

      query.expand = [ 'data.payment_intent' ]

      return query
    },
    goto(item) {
      const { status, id } = item

      status === 'draft' && !isInvoiceFromSubscription(item)
        ? this.$router.push({ name: 'invoice-edit', params: { id } })
        : this.$router.push({ name: 'invoice-detail', params: { id } })
    }
  },
  data() {
    return {
      headers: [
        {
          text: 'Amount',
          align: 'left',
          sortable: false,
        },
        {
          text: '',
          align: 'left',
          sortable: false
        },
        {
          text: 'Status',
          sortable: false,
        },
        {
          text: 'Invoice Number',
          sortable: false,
        },
        {
          text: 'Customer',
          sortable: false
        },
        {
          text: 'Due',
          sortable: false
        },
        {
          text: 'Created',
          sortable: false
        },
      ]
    }
  }
}
</script>
